import React, { useCallback, useState } from 'react'
import { Tooltip } from '@mui/material'
import EnsembleModal from './ensemble-modal'
import SettingsPowerIcon from '@mui/icons-material/SettingsPower'

export interface ViewEnsembleModalTriggerProps {
  portfolioId: string
  strategyCoin: string
  strategyId: string
  ensembles: Record<string, string>
}

const ConstraintsModalTrigger: React.FC<ViewEnsembleModalTriggerProps> = (props) => {
  const { portfolioId, strategyCoin, strategyId, ensembles } = props

  const [isModalOpen, setIsModalOpen] = useState<boolean>(false)

  const openModal = useCallback(() => {
    setIsModalOpen(true)
  }, [])

  const closeModal = useCallback(() => {
    setIsModalOpen(false)
  }, [])

  return (
    <>
      <EnsembleModal
        open={isModalOpen}
        onClose={closeModal}
        portfolioId={portfolioId}
        strategyCoin={strategyCoin}
        strategyId={strategyId}
        ensembles={ensembles}
      />

      <Tooltip title='Ensemble Agent'>
        <span>
          <SettingsPowerIcon onClick={openModal} />
        </span>
      </Tooltip>
    </>
  )
}

export default React.memo(ConstraintsModalTrigger)
